// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgNetworkReverse = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.9 1.25c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-2.15v3h2.75a2.75 2.75 0 0 1 2.75 2.75v2.75h2.15c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h2.15V13.5c0-.69-.56-1.25-1.25-1.25h-7c-.69 0-1.25.56-1.25 1.25v2.75H9.4c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h2.15V13.5a2.75 2.75 0 0 1 2.75-2.75h2.75v-3H9.1A1.35 1.35 0 0 1 7.75 6.4V2.6c0-.746.604-1.35 1.35-1.35zm-11.15 20h5.5v-3.5h-5.5zm11 0h5.5v-3.5h-5.5zm-5.5-15h5.5v-3.5h-5.5z"
    />
  </svg>
);
export const NetworkReverseIcon = forwardRef(SvgNetworkReverse);
